import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { PaymentMethodInterface } from 'common/types/entities/PaymentMethodInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createPaymentMethod(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): PaymentMethodInterface {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.PaymentMethod,
      parentId,
      masterBlockId,
    ),
    fontSize: 16,
  }
}
